import BrowserLanguage from '../../components/Util/BrowserLanguage';

let language = BrowserLanguage.getDefaultLanguage();
const countryListEN = [
  {
    name: 'Afghanistan',
    code: '+93',
  },
  {
    name: 'Aland Islands',
    code: '+358',
  },
  {
    name: 'Albania',
    code: '+355',
  },
  {
    name: 'Algeria',
    code: '+213',
  },
  {
    name: 'AmericanSamoa',
    code: '+1684',
  },
  {
    name: 'Andorra',
    code: '+376',
  },
  {
    name: 'Angola',
    code: '+244',
  },
  {
    name: 'Anguilla',
    code: '+1264',
  },
  {
    name: 'Antarctica',
    code: '+672',
  },
  {
    name: 'Antigua and Barbuda',
    code: '+1268',
  },
  {
    name: 'Argentina',
    code: '+54',
  },
  {
    name: 'Armenia',
    code: '+374',
  },
  {
    name: 'Aruba',
    code: '+297',
  },
  {
    name: 'Australia',
    code: '+61',
  },
  {
    name: 'Austria',
    code: '+43',
  },
  {
    name: 'Azerbaijan',
    code: '+994',
  },
  {
    name: 'Bahamas',
    code: '+1242',
  },
  {
    name: 'Bahrain',
    code: '+973',
  },
  {
    name: 'Bangladesh',
    code: '+880',
  },
  {
    name: 'Barbados',
    code: '+1246',
  },
  {
    name: 'Belarus',
    code: '+375',
  },
  {
    name: 'Belgium',
    code: '+32',
  },
  {
    name: 'Belize',
    code: '+501',
  },
  {
    name: 'Benin',
    code: '+229',
  },
  {
    name: 'Bermuda',
    code: '+1441',
  },
  {
    name: 'Bhutan',
    code: '+975',
  },
  {
    name: 'Bolivia, Plurinational State of',
    code: '+591',
  },
  {
    name: 'Bosnia and Herzegovina',
    code: '+387',
  },
  {
    name: 'Botswana',
    code: '+267',
  },
  {
    name: 'Brazil',
    code: '+55',
  },
  {
    name: 'British Indian Ocean Territory',
    code: '+246',
  },
  {
    name: 'Brunei Darussalam',
    code: '+673',
  },
  {
    name: 'Bulgaria',
    code: '+359',
  },
  {
    name: 'Burkina Faso',
    code: '+226',
  },
  {
    name: 'Burundi',
    code: '+257',
  },
  {
    name: 'Cambodia',
    code: '+855',
  },
  {
    name: 'Cameroon',
    code: '+237',
  },
  {
    name: 'Canada',
    code: '+1',
  },
  {
    name: 'Cape Verde',
    code: '+238',
  },
  {
    name: 'Cayman Islands',
    code: '+ 345',
  },
  {
    name: 'Central African Republic',
    code: '+236',
  },
  {
    name: 'Chad',
    code: '+235',
  },
  {
    name: 'Chile',
    code: '+56',
  },
  {
    name: 'China',
    code: '+86',
  },
  {
    name: 'Christmas Island',
    code: '+61',
  },
  {
    name: 'Cocos (Keeling) Islands',
    code: '+61',
  },
  {
    name: 'Colombia',
    code: '+57',
  },
  {
    name: 'Comoros',
    code: '+269',
  },
  {
    name: 'Congo',
    code: '+242',
  },
  {
    name: 'Congo, The Democratic Republic of the Congo',
    code: '+243',
  },
  {
    name: 'Cook Islands',
    code: '+682',
  },
  {
    name: 'Costa Rica',
    code: '+506',
  },
  {
    name: 'Cote d Ivoire',
    code: '+225',
  },
  {
    name: 'Croatia',
    code: '+385',
  },
  {
    name: 'Cuba',
    code: '+53',
  },
  {
    name: 'Cyprus',
    code: '+357',
  },
  {
    name: 'Czech Republic',
    code: '+420',
  },
  {
    name: 'Denmark',
    code: '+45',
  },
  {
    name: 'Djibouti',
    code: '+253',
  },
  {
    name: 'Dominica',
    code: '+1767',
  },
  {
    name: 'Dominican Republic',
    code: '+1849',
  },
  {
    name: 'Ecuador',
    code: '+593',
  },
  {
    name: 'Egypt',
    code: '+20',
  },
  {
    name: 'El Salvador',
    code: '+503',
  },
  {
    name: 'Equatorial Guinea',
    code: '+240',
  },
  {
    name: 'Eritrea',
    code: '+291',
  },
  {
    name: 'Estonia',
    code: '+372',
  },
  {
    name: 'Ethiopia',
    code: '+251',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: '+500',
  },
  {
    name: 'Faroe Islands',
    code: '+298',
  },
  {
    name: 'Fiji',
    code: '+679',
  },
  {
    name: 'Finland',
    code: '+358',
  },
  {
    name: 'France',
    code: '+33',
  },
  {
    name: 'French Guiana',
    code: '+594',
  },
  {
    name: 'French Polynesia',
    code: '+689',
  },
  {
    name: 'Gabon',
    code: '+241',
  },
  {
    name: 'Gambia',
    code: '+220',
  },
  {
    name: 'Georgia',
    code: '+995',
  },
  {
    name: 'Germany',
    code: '+49',
  },
  {
    name: 'Ghana',
    code: '+233',
  },
  {
    name: 'Gibraltar',
    code: '+350',
  },
  {
    name: 'Greece',
    code: '+30',
  },
  {
    name: 'Greenland',
    code: '+299',
  },
  {
    name: 'Grenada',
    code: '+1473',
  },
  {
    name: 'Guadeloupe',
    code: '+590',
  },
  {
    name: 'Guam',
    code: '+1671',
  },
  {
    name: 'Guatemala',
    code: '+502',
  },
  {
    name: 'Guernsey',
    code: '+44',
  },
  {
    name: 'Guinea',
    code: '+224',
  },
  {
    name: 'Guinea-Bissau',
    code: '+245',
  },
  {
    name: 'Guyana',
    code: '+595',
  },
  {
    name: 'Haiti',
    code: '+509',
  },
  {
    name: 'Holy See (Vatican City State)',
    code: '+379',
  },
  {
    name: 'Honduras',
    code: '+504',
  },
  {
    name: 'Hong Kong',
    code: '+852',
  },
  {
    name: 'Hungary',
    code: '+36',
  },
  {
    name: 'Iceland',
    code: '+354',
  },
  {
    name: 'India',
    code: '+91',
  },
  {
    name: 'Indonesia',
    code: '+62',
  },
  {
    name: 'Iran, Islamic Republic of Persian Gulf',
    code: '+98',
  },
  {
    name: 'Iraq',
    code: '+964',
  },
  {
    name: 'Ireland',
    code: '+353',
  },
  {
    name: 'Isle of Man',
    code: '+44',
  },
  {
    name: 'Israel',
    code: '+972',
  },
  {
    name: 'Italy',
    code: '+39',
  },
  {
    name: 'Jamaica',
    code: '+1876',
  },
  {
    name: 'Japan',
    code: '+81',
  },
  {
    name: 'Jersey',
    code: '+44',
  },
  {
    name: 'Jordan',
    code: '+962',
  },
  {
    name: 'Kazakhstan',
    code: '+77',
  },
  {
    name: 'Kenya',
    code: '+254',
  },
  {
    name: 'Kiribati',
    code: '+686',
  },
  {
    name: 'Korea, Democratic People s Republic of Korea',
    code: '+850',
  },
  {
    name: 'Korea, Republic of South Korea',
    code: '+82',
  },
  {
    name: 'Kuwait',
    code: '+965',
  },
  {
    name: 'Kyrgyzstan',
    code: '+996',
  },
  {
    name: 'Laos',
    code: '+856',
  },
  {
    name: 'Latvia',
    code: '+371',
  },
  {
    name: 'Lebanon',
    code: '+961',
  },
  {
    name: 'Lesotho',
    code: '+266',
  },
  {
    name: 'Liberia',
    code: '+231',
  },
  {
    name: 'Libyan Arab Jamahiriya',
    code: '+218',
  },
  {
    name: 'Liechtenstein',
    code: '+423',
  },
  {
    name: 'Lithuania',
    code: '+370',
  },
  {
    name: 'Luxembourg',
    code: '+352',
  },
  {
    name: 'Macao',
    code: '+853',
  },
  {
    name: 'Macedonia',
    code: '+389',
  },
  {
    name: 'Madagascar',
    code: '+261',
  },
  {
    name: 'Malawi',
    code: '+265',
  },
  {
    name: 'Malaysia',
    code: '+60',
  },
  {
    name: 'Maldives',
    code: '+960',
  },
  {
    name: 'Mali',
    code: '+223',
  },
  {
    name: 'Malta',
    code: '+356',
  },
  {
    name: 'Marshall Islands',
    code: '+692',
  },
  {
    name: 'Martinique',
    code: '+596',
  },
  {
    name: 'Mauritania',
    code: '+222',
  },
  {
    name: 'Mauritius',
    code: '+230',
  },
  {
    name: 'Mayotte',
    code: '+262',
  },
  {
    name: 'Mexico',
    code: '+52',
  },
  {
    name: 'Micronesia, Federated States of Micronesia',
    code: '+691',
  },
  {
    name: 'Moldova',
    code: '+373',
  },
  {
    name: 'Monaco',
    code: '+377',
  },
  {
    name: 'Mongolia',
    code: '+976',
  },
  {
    name: 'Montenegro',
    code: '+382',
  },
  {
    name: 'Montserrat',
    code: '+1664',
  },
  {
    name: 'Morocco',
    code: '+212',
  },
  {
    name: 'Mozambique',
    code: '+258',
  },
  {
    name: 'Myanmar',
    code: '+95',
  },
  {
    name: 'Namibia',
    code: '+264',
  },
  {
    name: 'Nauru',
    code: '+674',
  },
  {
    name: 'Nepal',
    code: '+977',
  },
  {
    name: 'Netherlands',
    code: '+31',
  },
  {
    name: 'Netherlands Antilles',
    code: '+599',
  },
  {
    name: 'New Caledonia',
    code: '+687',
  },
  {
    name: 'New Zealand',
    code: '+64',
  },
  {
    name: 'Nicaragua',
    code: '+505',
  },
  {
    name: 'Niger',
    code: '+227',
  },
  {
    name: 'Nigeria',
    code: '+234',
  },
  {
    name: 'Niue',
    code: '+683',
  },
  {
    name: 'Norfolk Island',
    code: '+672',
  },
  {
    name: 'Northern Mariana Islands',
    code: '+1670',
  },
  {
    name: 'Norway',
    code: '+47',
  },
  {
    name: 'Oman',
    code: '+968',
  },
  {
    name: 'Pakistan',
    code: '+92',
  },
  {
    name: 'Palau',
    code: '+680',
  },
  {
    name: 'Palestinian Territory, Occupied',
    code: '+970',
  },
  {
    name: 'Panama',
    code: '+507',
  },
  {
    name: 'Papua New Guinea',
    code: '+675',
  },
  {
    name: 'Paraguay',
    code: '+595',
  },
  {
    name: 'Peru',
    code: '+51',
  },
  {
    name: 'Philippines',
    code: '+63',
  },
  {
    name: 'Pitcairn',
    code: '+872',
  },
  {
    name: 'Poland',
    code: '+48',
  },
  {
    name: 'Portugal',
    code: '+351',
  },
  {
    name: 'Puerto Rico',
    code: '+1939',
  },
  {
    name: 'Qatar',
    code: '+974',
  },
  {
    name: 'Romania',
    code: '+40',
  },
  {
    name: 'Russia',
    code: '+7',
  },
  {
    name: 'Rwanda',
    code: '+250',
  },
  {
    name: 'Reunion',
    code: '+262',
  },
  {
    name: 'Saint Barthelemy',
    code: '+590',
  },
  {
    name: 'Saint Helena, Ascension and Tristan Da Cunha',
    code: '+290',
  },
  {
    name: 'Saint Kitts and Nevis',
    code: '+1869',
  },
  {
    name: 'Saint Lucia',
    code: '+1758',
  },
  {
    name: 'Saint Martin',
    code: '+590',
  },
  {
    name: 'Saint Pierre and Miquelon',
    code: '+508',
  },
  {
    name: 'Saint Vincent and the Grenadines',
    code: '+1784',
  },
  {
    name: 'Samoa',
    code: '+685',
  },
  {
    name: 'San Marino',
    code: '+378',
  },
  {
    name: 'Sao Tome and Principe',
    code: '+239',
  },
  {
    name: 'Saudi Arabia',
    code: '+966',
  },
  {
    name: 'Senegal',
    code: '+221',
  },
  {
    name: 'Serbia',
    code: '+381',
  },
  {
    name: 'Seychelles',
    code: '+248',
  },
  {
    name: 'Sierra Leone',
    code: '+232',
  },
  {
    name: 'Singapore',
    code: '+65',
  },
  {
    name: 'Slovakia',
    code: '+421',
  },
  {
    name: 'Slovenia',
    code: '+386',
  },
  {
    name: 'Solomon Islands',
    code: '+677',
  },
  {
    name: 'Somalia',
    code: '+252',
  },
  {
    name: 'South Africa',
    code: '+27',
  },
  {
    name: 'South Sudan',
    code: '+211',
  },
  {
    name: 'South Georgia and the South Sandwich Islands',
    code: '+500',
  },
  {
    name: 'Spain',
    code: '+34',
  },
  {
    name: 'Sri Lanka',
    code: '+94',
  },
  {
    name: 'Sudan',
    code: '+249',
  },
  {
    name: 'Suriname',
    code: '+597',
  },
  {
    name: 'Svalbard and Jan Mayen',
    code: '+47',
  },
  {
    name: 'Swaziland',
    code: '+268',
  },
  {
    name: 'Sweden',
    code: '+46',
  },
  {
    name: 'Switzerland',
    code: '+41',
  },
  {
    name: 'Syrian Arab Republic',
    code: '+963',
  },
  {
    name: 'Taiwan',
    code: '+886',
  },
  {
    name: 'Tajikistan',
    code: '+992',
  },
  {
    name: 'Tanzania, United Republic of Tanzania',
    code: '+255',
  },
  {
    name: 'Thailand',
    code: '+66',
  },
  {
    name: 'Timor-Leste',
    code: '+670',
  },
  {
    name: 'Togo',
    code: '+228',
  },
  {
    name: 'Tokelau',
    code: '+690',
  },
  {
    name: 'Tonga',
    code: '+676',
  },
  {
    name: 'Trinidad and Tobago',
    code: '+1868',
  },
  {
    name: 'Tunisia',
    code: '+216',
  },
  {
    name: 'Turkey',
    code: '+90',
  },
  {
    name: 'Turkmenistan',
    code: '+993',
  },
  {
    name: 'Turks and Caicos Islands',
    code: '+1649',
  },
  {
    name: 'Tuvalu',
    code: '+688',
  },
  {
    name: 'Uganda',
    code: '+256',
  },
  {
    name: 'Ukraine',
    code: '+380',
  },
  {
    name: 'UAE',
    code: '+971',
  },
  {
    name: 'UK',
    code: '+44',
  },
  {
    name: 'USA',
    code: '+1',
  },
  {
    name: 'Uruguay',
    code: '+598',
  },
  {
    name: 'Uzbekistan',
    code: '+998',
  },
  {
    name: 'Vanuatu',
    code: '+678',
  },
  {
    name: 'Venezuela, Bolivarian Republic of Venezuela',
    code: '+58',
  },
  {
    name: 'Vietnam',
    code: '+84',
  },
  {
    name: 'Virgin Islands, British',
    code: '+1284',
  },
  {
    name: 'Virgin Islands, U.S.',
    code: '+1340',
  },
  {
    name: 'Wallis and Futuna',
    code: '+681',
  },
  {
    name: 'Yemen',
    code: '+967',
  },
  {
    name: 'Zambia',
    code: '+260',
  },
  {
    name: 'Zimbabwe',
    code: '+263',
  },
];

const countryListES = [
  {
    name: 'Afganistán',
    code: '+93',
  },
  {
    name: 'Islas Aland',
    code: '+358',
  },
  {
    name: 'Albania',
    code: '+355',
  },
  {
    name: 'Argelia',
    code: '+213',
  },
  {
    name: 'AmericanSamoa',
    code: '+1684',
  },
  {
    name: 'Andorra',
    code: '+376',
  },
  {
    name: 'Angola',
    code: '+244',
  },
  {
    name: 'Anguila',
    code: '+1264',
  },
  {
    name: 'Antártida',
    code: '+672',
  },
  {
    name: 'Antigua y Barbuda',
    code: '+1268',
  },
  {
    name: 'Argentina',
    code: '+54',
  },
  {
    name: 'Armenia',
    code: '+374',
  },
  {
    name: 'Aruba',
    code: '+297',
  },
  {
    name: 'Australia',
    code: '+61',
  },
  {
    name: 'Austria',
    code: '+43',
  },
  {
    name: 'Azerbaiyán',
    code: '+994',
  },
  {
    name: 'Bahamas',
    code: '+1242',
  },
  {
    name: 'Bahrein',
    code: '+973',
  },
  {
    name: 'Bangladesh',
    code: '+880',
  },
  {
    name: 'Barbados',
    code: '+1246',
  },
  {
    name: 'Bielorrusia',
    code: '+375',
  },
  {
    name: 'Bélgica',
    code: '+32',
  },
  {
    name: 'Belice',
    code: '+501',
  },
  {
    name: 'Benin',
    code: '+229',
  },
  {
    name: 'Bermudas',
    code: '+1441',
  },
  {
    name: 'Bután',
    code: '+975',
  },
  {
    name: 'Bolivia, Estado Plurinacional de',
    code: '+591',
  },
  {
    name: 'Bosnia y Herzegovina',
    code: '+387',
  },
  {
    name: 'Botswana',
    code: '+267',
  },
  {
    name: 'Brasil',
    code: '+55',
  },
  {
    name: 'Territorio Británico del Océano Índico',
    code: '+246',
  },
  {
    name: 'Brunei Darussalam',
    code: '+673',
  },
  {
    name: 'Bulgaria',
    code: '+359',
  },
  {
    name: 'Burkina Faso',
    code: '+226',
  },
  {
    name: 'Burundi',
    code: '+257',
  },
  {
    name: 'Camboya',
    code: '+855',
  },
  {
    name: 'Camerún',
    code: '+237',
  },
  {
    name: 'Canadá',
    code: '+1',
  },
  {
    name: 'Cabo Verde',
    code: '+238',
  },
  {
    name: 'Islas Caimán',
    code: '+ 345',
  },
  {
    name: 'República Centroafricana',
    code: '+236',
  },
  {
    name: 'Chad',
    code: '+235',
  },
  {
    name: 'Chile',
    code: '+56',
  },
  {
    name: 'China',
    code: '+86',
  },
  {
    name: 'Isla de Navidad',
    code: '+61',
  },
  {
    name: 'Islas Cocos (Keeling)',
    code: '+61',
  },
  {
    name: 'Colombia',
    code: '+57',
  },
  {
    name: 'Comoras',
    code: '+269',
  },
  {
    name: 'Congo',
    code: '+242',
  },
  {
    name: 'Congo, República Democrática del Congo',
    code: '+243',
  },
  {
    name: 'Islas Cook',
    code: '+682',
  },
  {
    name: 'Costa Rica',
    code: '+506',
  },
  {
    name: 'Cote d Ivoire',
    code: '+225',
  },
  {
    name: 'Croacia',
    code: '+385',
  },
  {
    name: 'Cuba',
    code: '+53',
  },
  {
    name: 'Chipre',
    code: '+357',
  },
  {
    name: 'República Checa',
    code: '+420',
  },
  {
    name: 'Dinamarca',
    code: '+45',
  },
  {
    name: 'Djibouti',
    code: '+253',
  },
  {
    name: 'Dominica',
    code: '+1767',
  },
  {
    name: 'República Dominicana',
    code: '+1849',
  },
  {
    name: 'Ecuador',
    code: '+593',
  },
  {
    name: 'Egipto',
    code: '+20',
  },
  {
    name: 'El Salvador',
    code: '+503',
  },
  {
    name: 'Guinea Ecuatorial',
    code: '+240',
  },
  {
    name: 'Eritrea',
    code: '+291',
  },
  {
    name: 'Estonia',
    code: '+372',
  },
  {
    name: 'Etiopía',
    code: '+251',
  },
  {
    name: 'Falkland Islands (Malvinas)',
    code: '+500',
  },
  {
    name: 'Islas Feroe',
    code: '+298',
  },
  {
    name: 'Fiji',
    code: '+679',
  },
  {
    name: 'Finlandia',
    code: '+358',
  },
  {
    name: 'Francia',
    code: '+33',
  },
  {
    name: 'Guayana Francesa',
    code: '+594',
  },
  {
    name: 'Polinesia Francesa',
    code: '+689',
  },
  {
    name: 'Gabón',
    code: '+241',
  },
  {
    name: 'Gambia',
    code: '+220',
  },
  {
    name: 'Georgia',
    code: '+995',
  },
  {
    name: 'Alemania',
    code: '+49',
  },
  {
    name: 'Ghana',
    code: '+233',
  },
  {
    name: 'Gibraltar',
    code: '+350',
  },
  {
    name: 'Grecia',
    code: '+30',
  },
  {
    name: 'Groenlandia',
    code: '+299',
  },
  {
    name: 'Granada',
    code: '+1473',
  },
  {
    name: 'Guadalupe',
    code: '+590',
  },
  {
    name: 'Guam',
    code: '+1671',
  },
  {
    name: 'Guatemala',
    code: '+502',
  },
  {
    name: 'Guernsey',
    code: '+44',
  },
  {
    name: 'Guinea',
    code: '+224',
  },
  {
    name: 'Guinea-Bissau',
    code: '+245',
  },
  {
    name: 'Guyana',
    code: '+595',
  },
  {
    name: 'Haití',
    code: '+509',
  },
  {
    name: 'Santa Sede (Estado de la Ciudad del Vaticano)',
    code: '+379',
  },
  {
    name: 'Honduras',
    code: '+504',
  },
  {
    name: 'Hong Kong',
    code: '+852',
  },
  {
    name: 'Hungría',
    code: '+36',
  },
  {
    name: 'Islandia',
    code: '+354',
  },
  {
    name: 'India',
    code: '+91',
  },
  {
    name: 'Indonesia',
    code: '+62',
  },
  {
    name: 'Irán, República Islámica del Golfo Pérsico',
    code: '+98',
  },
  {
    name: 'Irak',
    code: '+964',
  },
  {
    name: 'Irlanda',
    code: '+353',
  },
  {
    name: 'Isla de Man',
    code: '+44',
  },
  {
    name: 'Israel',
    code: '+972',
  },
  {
    name: 'Italia',
    code: '+39',
  },
  {
    name: 'Jamaica',
    code: '+1876',
  },
  {
    name: 'Japón',
    code: '+81',
  },
  {
    name: 'Jersey',
    code: '+44',
  },
  {
    name: 'Jordan',
    code: '+962',
  },
  {
    name: 'Kazajstán',
    code: '+77',
  },
  {
    name: 'Kenia',
    code: '+254',
  },
  {
    name: 'Kiribati',
    code: '+686',
  },
  {
    name: 'Corea, República Popular Democrática de Corea',
    code: '+850',
  },
  {
    name: 'Corea, República de Corea del Sur',
    code: '+82',
  },
  {
    name: 'Kuwait',
    code: '+965',
  },
  {
    name: 'Kirguistán',
    code: '+996',
  },
  {
    name: 'Laos',
    code: '+856',
  },
  {
    name: 'Letonia',
    code: '+371',
  },
  {
    name: 'Líbano',
    code: '+961',
  },
  {
    name: 'Lesotho',
    code: '+266',
  },
  {
    name: 'Liberia',
    code: '+231',
  },
  {
    name: 'Jamahiriya Árabe Libia',
    code: '+218',
  },
  {
    name: 'Liechtenstein',
    code: '+423',
  },
  {
    name: 'Lituania',
    code: '+370',
  },
  {
    name: 'Luxemburgo',
    code: '+352',
  },
  {
    name: 'Macao',
    code: '+853',
  },
  {
    name: 'Macedonia',
    code: '+389',
  },
  {
    name: 'Madagascar',
    code: '+261',
  },
  {
    name: 'Malawi',
    code: '+265',
  },
  {
    name: 'Malasia',
    code: '+60',
  },
  {
    name: 'Maldivas',
    code: '+960',
  },
  {
    name: 'Mali',
    code: '+223',
  },
  {
    name: 'Malta',
    code: '+356',
  },
  {
    name: 'Islas Marshall',
    code: '+692',
  },
  {
    name: 'Martinica',
    code: '+596',
  },
  {
    name: 'Mauritania',
    code: '+222',
  },
  {
    name: 'Mauricio',
    code: '+230',
  },
  {
    name: 'Mayotte',
    code: '+262',
  },
  {
    name: 'México',
    code: '+52',
  },
  {
    name: 'Micronesia, Estados Federados de Micronesia',
    code: '+691',
  },
  {
    name: 'Moldavia',
    code: '+373',
  },
  {
    name: 'Mónaco',
    code: '+377',
  },
  {
    name: 'Mongolia',
    code: '+976',
  },
  {
    name: 'Montenegro',
    code: '+382',
  },
  {
    name: 'Montserrat',
    code: '+1664',
  },
  {
    name: 'Marruecos',
    code: '+212',
  },
  {
    name: 'Mozambique',
    code: '+258',
  },
  {
    name: 'Myanmar',
    code: '+95',
  },
  {
    name: 'Namibia',
    code: '+264',
  },
  {
    name: 'Nauru',
    code: '+674',
  },
  {
    name: 'Nepal',
    code: '+977',
  },
  {
    name: 'Países Bajos',
    code: '+31',
  },
  {
    name: 'Antillas Holandesas',
    code: '+599',
  },
  {
    name: 'Nueva Caledonia',
    code: '+687',
  },
  {
    name: 'Nueva Zelanda',
    code: '+64',
  },
  {
    name: 'Nicaragua',
    code: '+505',
  },
  {
    name: 'Níger',
    code: '+227',
  },
  {
    name: 'Nigeria',
    code: '+234',
  },
  {
    name: 'Niue',
    code: '+683',
  },
  {
    name: 'Isla Norfolk',
    code: '+672',
  },
  {
    name: 'Islas Marianas del Norte',
    code: '+1670',
  },
  {
    name: 'Noruega',
    code: '+47',
  },
  {
    name: 'Omán',
    code: '+968',
  },
  {
    name: 'Pakistán',
    code: '+92',
  },
  {
    name: 'Palau',
    code: '+680',
  },
  {
    name: 'Territorio Palestino, Ocupado',
    code: '+970',
  },
  {
    name: 'Panamá',
    code: '+507',
  },
  {
    name: 'Papua Nueva Guinea',
    code: '+675',
  },
  {
    name: 'Paraguay',
    code: '+595',
  },
  {
    name: 'Perú',
    code: '+51',
  },
  {
    name: 'Filipinas',
    code: '+63',
  },
  {
    name: 'Pitcairn',
    code: '+872',
  },
  {
    name: 'Polonia',
    code: '+48',
  },
  {
    name: 'Portugal',
    code: '+351',
  },
  {
    name: 'Puerto Rico',
    code: '+1939',
  },
  {
    name: 'Qatar',
    code: '+974',
  },
  {
    name: 'Rumania',
    code: '+40',
  },
  {
    name: 'Rusia',
    code: '+7',
  },
  {
    name: 'Ruanda',
    code: '+250',
  },
  {
    name: 'Reunión',
    code: '+262',
  },
  {
    name: 'San Bartolomé',
    code: '+590',
  },
  {
    name: 'Santa Elena, Ascensión y Tristán de Acuña',
    code: '+290',
  },
  {
    name: 'San Cristóbal y Nieves',
    code: '+1869',
  },
  {
    name: 'Santa Lucía',
    code: '+1758',
  },
  {
    name: 'San Martín',
    code: '+590',
  },
  {
    name: 'San Pedro y Miquelón',
    code: '+508',
  },
  {
    name: 'San Vicente y las Granadinas',
    code: '+1784',
  },
  {
    name: 'Samoa',
    code: '+685',
  },
  {
    name: 'San Marino',
    code: '+378',
  },
  {
    name: 'Santo Tomé y Príncipe',
    code: '+239',
  },
  {
    name: 'Arabia Saudita',
    code: '+966',
  },
  {
    name: 'Senegal',
    code: '+221',
  },
  {
    name: 'Serbia',
    code: '+381',
  },
  {
    name: 'Seychelles',
    code: '+248',
  },
  {
    name: 'Sierra Leona',
    code: '+232',
  },
  {
    name: 'Singapur',
    code: '+65',
  },
  {
    name: 'Eslovaquia',
    code: '+421',
  },
  {
    name: 'Eslovenia',
    code: '+386',
  },
  {
    name: 'Islas Salomón',
    code: '+677',
  },
  {
    name: 'Somalia',
    code: '+252',
  },
  {
    name: 'Sudáfrica',
    code: '+27',
  },
  {
    name: 'Sudán del Sur',
    code: '+211',
  },
  {
    name: 'Islas Georgias del Sur y Sandwich del Sur',
    code: '+500',
  },
  {
    name: 'España',
    code: '+34',
  },
  {
    name: 'Sri Lanka',
    code: '+94',
  },
  {
    name: 'Sudán',
    code: '+249',
  },
  {
    name: 'Surinam',
    code: '+597',
  },
  {
    name: 'Svalbard y Jan Mayen',
    code: '+47',
  },
  {
    name: 'Swazilandia',
    code: '+268',
  },
  {
    name: 'Suecia',
    code: '+46',
  },
  {
    name: 'Suiza',
    code: '+41',
  },
  {
    name: 'República Árabe Siria',
    code: '+963',
  },
  {
    name: 'Taiwán',
    code: '+886',
  },
  {
    name: 'Tayikistán',
    code: '+992',
  },
  {
    name: 'Tanzania, República Unida de Tanzania',
    code: '+255',
  },
  {
    name: 'Tailandia',
    code: '+66',
  },
  {
    name: 'Timor-Leste',
    code: '+670',
  },
  {
    name: 'Togo',
    code: '+228',
  },
  {
    name: 'Tokelau',
    code: '+690',
  },
  {
    name: 'Tonga',
    code: '+676',
  },
  {
    name: 'Trinidad y Tobago',
    code: '+1868',
  },
  {
    name: 'Túnez',
    code: '+216',
  },
  {
    name: 'Turquía',
    code: '+90',
  },
  {
    name: 'Turkmenistán',
    code: '+993',
  },
  {
    name: 'Islas Turcas y Caicos',
    code: '+1649',
  },
  {
    name: 'Tuvalu',
    code: '+688',
  },
  {
    name: 'Uganda',
    code: '+256',
  },
  {
    name: 'Ucrania',
    code: '+380',
  },
  {
    name: 'Emiratos Árabes Unidos',
    code: '+971',
  },
  {
    name: 'Reino Unido',
    code: '+44',
  },
  {
    name: 'Estados Unidos',
    code: '+1',
  },
  {
    name: 'Uruguay',
    code: '+598',
  },
  {
    name: 'Uzbekistán',
    code: '+998',
  },
  {
    name: 'Vanuatu',
    code: '+678',
  },
  {
    name: 'Venezuela, República Bolivariana de Venezuela',
    code: '+58',
  },
  {
    name: 'Vietnam',
    code: '+84',
  },
  {
    name: 'Islas Vírgenes Británicas',
    code: '+1284',
  },
  {
    name: 'Islas Vírgenes, EE. UU.',
    code: '+1340',
  },
  {
    name: 'Wallis y Futuna',
    code: '+681',
  },
  {
    name: 'Yemen',
    code: '+967',
  },
  {
    name: 'Zambia',
    code: '+260',
  },
  {
    name: 'Zimbabwe',
    code: '+263',
  },
];
const countryListZH = [
  {
    name: '阿富汗',
    code: '+93',
  },
  {
    name: '奥兰群岛',
    code: '+358',
  },
  {
    name: '阿尔巴尼亚',
    code: '+355',
  },
  {
    name: '阿尔及利亚',
    code: '+213',
  },
  {
    name: '美属萨摩亚',
    code: '+1684',
  },
  {
    name: '安道尔',
    code: '+376',
  },
  {
    name: '安哥拉',
    code: '+244',
  },
  {
    name: '安圭拉',
    code: '+1264',
  },
  {
    name: '南极',
    code: '+672',
  },
  {
    name: '安提瓜和巴布达',
    code: '+1268',
  },
  {
    name: '阿根廷',
    code: '+54',
  },
  {
    name: '亚美尼亚',
    code: '+374',
  },
  {
    name: '阿鲁巴',
    code: '+297',
  },
  {
    name: '澳大利亚',
    code: '+61',
  },
  {
    name: '奥地利',
    code: '+43',
  },
  {
    name: '阿塞拜疆',
    code: '+994',
  },
  {
    name: '巴哈马',
    code: '+1242',
  },
  {
    name: '巴林',
    code: '+973',
  },
  {
    name: '孟加拉国',
    code: '+880',
  },
  {
    name: '巴巴多斯',
    code: '+1246',
  },
  {
    name: '白俄罗斯',
    code: '+375',
  },
  {
    name: '比利时',
    code: '+32',
  },
  {
    name: '伯利兹',
    code: '+501',
  },
  {
    name: '贝宁',
    code: '+229',
  },
  {
    name: '百慕大',
    code: '+1441',
  },
  {
    name: '不丹',
    code: '+975',
  },
  {
    name: '多民族玻利维亚国',
    code: '+591',
  },
  {
    name: '波斯尼亚和黑塞哥维那',
    code: '+387',
  },
  {
    name: '博茨瓦纳',
    code: '+267',
  },
  {
    name: '巴西',
    code: '+55',
  },
  {
    name: '英属印度洋领地',
    code: '+246',
  },
  {
    name: '文莱达鲁萨兰国',
    code: '+673',
  },
  {
    name: '保加利亚',
    code: '+359',
  },
  {
    name: '布基纳法索',
    code: '+226',
  },
  {
    name: '布隆迪',
    code: '+257',
  },
  {
    name: '柬埔寨',
    code: '+855',
  },
  {
    name: '喀麦隆',
    code: '+237',
  },
  {
    name: '加拿大',
    code: '+1',
  },
  {
    name: '佛得角',
    code: '+238',
  },
  {
    name: '开曼群岛',
    code: '+ 345',
  },
  {
    name: '中非共和国',
    code: '+236',
  },
  {
    name: '乍得',
    code: '+235',
  },
  {
    name: '智利',
    code: '+56',
  },
  {
    name: '中国',
    code: '+86',
  },
  {
    name: '圣诞岛',
    code: '+61',
  },
  {
    name: '科科斯（基林）群岛',
    code: '+61',
  },
  {
    name: '哥伦比亚',
    code: '+57',
  },
  {
    name: '科摩罗',
    code: '+269',
  },
  {
    name: '刚果',
    code: '+242',
  },
  {
    name: '刚果,刚果民主共和国',
    code: '+243',
  },
  {
    name: '库克群岛',
    code: '+682',
  },
  {
    name: '哥斯达黎加',
    code: '+506',
  },
  {
    name: '科特迪瓦',
    code: '+225',
  },
  {
    name: '克罗地亚',
    code: '+385',
  },
  {
    name: '古巴',
    code: '+53',
  },
  {
    name: '塞浦路斯',
    code: '+357',
  },
  {
    name: '捷克共和国',
    code: '+420',
  },
  {
    name: '丹麦',
    code: '+45',
  },
  {
    name: '吉布提',
    code: '+253',
  },
  {
    name: '多米尼加',
    code: '+1767',
  },
  {
    name: '多米尼加共和国',
    code: '+1849',
  },
  {
    name: '厄瓜多尔',
    code: '+593',
  },
  {
    name: '埃及',
    code: '+20',
  },
  {
    name: '萨尔瓦多',
    code: '+503',
  },
  {
    name: '赤道几内亚',
    code: '+240',
  },
  {
    name: '厄立特里亚',
    code: '+291',
  },
  {
    name: '爱沙尼亚',
    code: '+372',
  },
  {
    name: '埃塞俄比亚',
    code: '+251',
  },
  {
    name: '福克兰群岛（马尔维纳斯）',
    code: '+500',
  },
  {
    name: '法罗群岛',
    code: '+298',
  },
  {
    name: '斐济',
    code: '+679',
  },
  {
    name: '芬兰',
    code: '+358',
  },
  {
    name: '法国',
    code: '+33',
  },
  {
    name: '法属圭亚那',
    code: '+594',
  },
  {
    name: '法属波利尼西亚',
    code: '+689',
  },
  {
    name: '加蓬',
    code: '+241',
  },
  {
    name: '冈比亚',
    code: '+220',
  },
  {
    name: '格鲁吉亚',
    code: '+995',
  },
  {
    name: '德国',
    code: '+49',
  },
  {
    name: '加纳',
    code: '+233',
  },
  {
    name: '直布罗陀',
    code: '+350',
  },
  {
    name: '希腊',
    code: '+30',
  },
  {
    name: '格陵兰',
    code: '+299',
  },
  {
    name: '格林纳达',
    code: '+1473',
  },
  {
    name: '瓜德罗普',
    code: '+590',
  },
  {
    name: '关岛',
    code: '+1671',
  },
  {
    name: '危地马拉',
    code: '+502',
  },
  {
    name: '根西岛',
    code: '+44',
  },
  {
    name: '几内亚',
    code: '+224',
  },
  {
    name: '几内亚比绍',
    code: '+245',
  },
  {
    name: '圭亚那',
    code: '+595',
  },
  {
    name: '海地',
    code: '+509',
  },
  {
    name: '教廷（梵蒂冈城邦）',
    code: '+379',
  },
  {
    name: '洪都拉斯',
    code: '+504',
  },
  {
    name: '香港',
    code: '+852',
  },
  {
    name: '匈牙利',
    code: '+36',
  },
  {
    name: '冰岛',
    code: '+354',
  },
  {
    name: '印度',
    code: '+91',
  },
  {
    name: '印度尼西亚',
    code: '+62',
  },
  {
    name: '伊朗,波斯湾伊斯兰共和国',
    code: '+98',
  },
  {
    name: '伊拉克',
    code: '+964',
  },
  {
    name: '爱尔兰',
    code: '+353',
  },
  {
    name: '马恩岛',
    code: '+44',
  },
  {
    name: '以色列',
    code: '+972',
  },
  {
    name: '意大利',
    code: '+39',
  },
  {
    name: '牙买加',
    code: '+1876',
  },
  {
    name: '日本',
    code: '+81',
  },
  {
    name: '球衣',
    code: '+44',
  },
  {
    name: '乔丹',
    code: '+962',
  },
  {
    name: '哈萨克斯坦',
    code: '+77',
  },
  {
    name: '肯尼亚',
    code: '+254',
  },
  {
    name: '基里巴斯',
    code: '+686',
  },
  {
    name: '朝鲜,朝鲜民主主义人民共和国',
    code: '+850',
  },
  {
    name: '韩国,大韩民国',
    code: '+82',
  },
  {
    name: '科威特',
    code: '+965',
  },
  {
    name: '吉尔吉斯斯坦',
    code: '+996',
  },
  {
    name: '老挝',
    code: '+856',
  },
  {
    name: '拉脱维亚',
    code: '+371',
  },
  {
    name: '黎巴嫩',
    code: '+961',
  },
  {
    name: '莱索托',
    code: '+266',
  },
  {
    name: '利​​比里亚',
    code: '+231',
  },
  {
    name: '阿拉伯利比亚民众国',
    code: '+218',
  },
  {
    name: '列支敦士登',
    code: '+423',
  },
  {
    name: '立陶宛',
    code: '+370',
  },
  {
    name: '卢森堡',
    code: '+352',
  },
  {
    name: '澳门',
    code: '+853',
  },
  {
    name: '马其顿',
    code: '+389',
  },
  {
    name: '马达加斯加',
    code: '+261',
  },
  {
    name: '马拉维',
    code: '+265',
  },
  {
    name: '马来西亚',
    code: '+60',
  },
  {
    name: '马尔代夫',
    code: '+960',
  },
  {
    name: '马里',
    code: '+223',
  },
  {
    name: '马耳他',
    code: '+356',
  },
  {
    name: '马绍尔群岛',
    code: '+692',
  },
  {
    name: '马提尼克',
    code: '+596',
  },
  {
    name: '毛里塔尼亚',
    code: '+222',
  },
  {
    name: '毛里求斯',
    code: '+230',
  },
  {
    name: '马约特岛',
    code: '+262',
  },
  {
    name: '墨西哥',
    code: '+52',
  },
  {
    name: '密克罗尼西亚,密克罗尼西亚联邦',
    code: '+691',
  },
  {
    name: '摩尔多瓦',
    code: '+373',
  },
  {
    name: '摩纳哥',
    code: '+377',
  },
  {
    name: '蒙古',
    code: '+976',
  },
  {
    name: '黑山',
    code: '+382',
  },
  {
    name: '蒙特塞拉特',
    code: '+1664',
  },
  {
    name: '摩洛哥',
    code: '+212',
  },
  {
    name: '莫桑比克',
    code: '+258',
  },
  {
    name: '缅甸',
    code: '+95',
  },
  {
    name: '纳米比亚',
    code: '+264',
  },
  {
    name: '瑙鲁',
    code: '+674',
  },
  {
    name: '尼泊尔',
    code: '+977',
  },
  {
    name: '荷兰',
    code: '+31',
  },
  {
    name: '荷属安的列斯',
    code: '+599',
  },
  {
    name: '新喀里多尼亚',
    code: '+687',
  },
  {
    name: '新西兰',
    code: '+64',
  },
  {
    name: '尼加拉瓜',
    code: '+505',
  },
  {
    name: '尼日尔',
    code: '+227',
  },
  {
    name: '尼日利亚',
    code: '+234',
  },
  {
    name: '纽埃',
    code: '+683',
  },
  {
    name: '诺福克岛',
    code: '+672',
  },
  {
    name: '北马里亚纳群岛',
    code: '+1670',
  },
  {
    name: '挪威',
    code: '+47',
  },
  {
    name: '阿曼',
    code: '+968',
  },
  {
    name: '巴基斯坦',
    code: '+92',
  },
  {
    name: '帕劳',
    code: '+680',
  },
  {
    name: '巴勒斯坦领土,被占领',
    code: '+970',
  },
  {
    name: '巴拿马',
    code: '+507',
  },
  {
    name: '巴布亚新几内亚',
    code: '+675',
  },
  {
    name: '巴拉圭',
    code: '+595',
  },
  {
    name: '秘鲁',
    code: '+51',
  },
  {
    name: '菲律宾',
    code: '+63',
  },
  {
    name: '皮特凯恩',
    code: '+872',
  },
  {
    name: '波兰',
    code: '+48',
  },
  {
    name: '葡萄牙',
    code: '+351',
  },
  {
    name: '波多黎各',
    code: '+1939',
  },
  {
    name: '卡塔尔',
    code: '+974',
  },
  {
    name: '罗马尼亚',
    code: '+40',
  },
  {
    name: '俄罗斯',
    code: '+7',
  },
  {
    name: '卢旺达',
    code: '+250',
  },
  {
    name: '重聚',
    code: '+262',
  },
  {
    name: '圣巴泰勒米',
    code: '+590',
  },
  {
    name: '圣赫勒拿,阿森松岛和特里斯坦达库尼亚',
    code: '+290',
  },
  {
    name: '圣基茨和尼维斯',
    code: '+1869',
  },
  {
    name: '圣卢西亚',
    code: '+1758',
  },
  {
    name: '圣马丁',
    code: '+590',
  },
  {
    name: '圣皮埃尔和密克隆',
    code: '+508',
  },
  {
    name: '圣文森特和格林纳丁斯',
    code: '+1784',
  },
  {
    name: '萨摩亚',
    code: '+685',
  },
  {
    name: '圣马力诺',
    code: '+378',
  },
  {
    name: '圣多美和普林西比',
    code: '+239',
  },
  {
    name: '沙特阿拉伯',
    code: '+966',
  },
  {
    name: '塞内加尔',
    code: '+221',
  },
  {
    name: '塞尔维亚',
    code: '+381',
  },
  {
    name: '塞舌尔',
    code: '+248',
  },
  {
    name: '塞拉利昂',
    code: '+232',
  },
  {
    name: '新加坡',
    code: '+65',
  },
  {
    name: '斯洛伐克',
    code: '+421',
  },
  {
    name: '斯洛文尼亚',
    code: '+386',
  },
  {
    name: '所罗门群岛',
    code: '+677',
  },
  {
    name: '索马里',
    code: '+252',
  },
  {
    name: '南非',
    code: '+27',
  },
  {
    name: '南苏丹',
    code: '+211',
  },
  {
    name: '南乔治亚岛和南桑威奇群岛',
    code: '+500',
  },
  {
    name: '西班牙',
    code: '+34',
  },
  {
    name: '斯里兰卡',
    code: '+94',
  },
  {
    name: '苏丹',
    code: '+249',
  },
  {
    name: '苏里南',
    code: '+597',
  },
  {
    name: '斯瓦尔巴和扬马延',
    code: '+47',
  },
  {
    name: '斯威士兰',
    code: '+268',
  },
  {
    name: '瑞典',
    code: '+46',
  },
  {
    name: '瑞士',
    code: '+41',
  },
  {
    name: '阿拉伯叙利亚共和国',
    code: '+963',
  },
  {
    name: '台湾',
    code: '+886',
  },
  {
    name: '塔吉克斯坦',
    code: '+992',
  },
  {
    name: '坦桑尼亚,坦桑尼亚联合共和国',
    code: '+255',
  },
  {
    name: '泰国',
    code: '+66',
  },
  {
    name: '东帝汶',
    code: '+670',
  },
  {
    name: '多哥',
    code: '+228',
  },
  {
    name: '托克劳',
    code: '+690',
  },
  {
    name: '汤加',
    code: '+676',
  },
  {
    name: '特立尼达和多巴哥',
    code: '+1868',
  },
  {
    name: '突尼斯',
    code: '+216',
  },
  {
    name: '土耳其',
    code: '+90',
  },
  {
    name: '土库曼斯坦',
    code: '+993',
  },
  {
    name: '特克斯和凯科斯群岛',
    code: '+1649',
  },
  {
    name: '图瓦卢',
    code: '+688',
  },
  {
    name: '乌干达',
    code: '+256',
  },
  {
    name: '乌克兰',
    code: '+380',
  },
  {
    name: '阿拉伯联合酋长国',
    code: '+971',
  },
  {
    name: '英国',
    code: '+44',
  },
  {
    name: '美国',
    code: '+1',
  },
  {
    name: '乌拉圭',
    code: '+598',
  },
  {
    name: '乌兹别克斯坦',
    code: '+998',
  },
  {
    name: '瓦努阿图',
    code: '+678',
  },
  {
    name: '委内瑞拉,委内瑞拉玻利瓦尔共和国',
    code: '+58',
  },
  {
    name: '越南',
    code: '+84',
  },
  {
    name: '英属维尔京群岛',
    code: '+1284',
  },
  {
    name: '美国维尔京群岛',
    code: '+1340',
  },
  {
    name: '瓦利斯和富图纳',
    code: '+681',
  },
  {
    name: '也门',
    code: '+967',
  },
  {
    name: '赞比亚',
    code: '+260',
  },
  {
    name: '津巴布韦',
    code: '+263',
  },
];
//export const countryList = language === 'en' ? countryListEN : language === 'es' ? countryListES : countryListZH;

export const countryList =countryListEN;